import { Component } from '@angular/core';
import { OfferFormComponent } from "../../offers/offer-form/offer-form.component";
import { ActivatedRoute, RouterLink } from "@angular/router";
import { JobFormComponent } from "../job-form/job-form.component";
import {JsonPipe, NgIf} from "@angular/common";
import { ClrIconModule } from "@clr/angular";
import { ClarityIcons, twoWayArrowsIcon } from "@cds/core/icon";
import { Jobs } from "../../../_shared/interfaces";
import { AlertService, IAlertType, JobsStoreService } from "../../../_shared/services";

import { environment as env } from '../../../../environments/environment';

@Component({
  selector: 'app-job-update',
  standalone: true,
  imports: [
    OfferFormComponent,
    RouterLink,
    JobFormComponent,
    NgIf,
    ClrIconModule,
    JsonPipe
  ],
  templateUrl: './job-update.component.html',
  styleUrl: './job-update.component.sass'
})
export class JobUpdateComponent {
  projectId: string = '';
  jobId: number = 0;
  jobs: Jobs[] = [];
  devMode: boolean;

  constructor(
    private jobss: JobsStoreService,
    private alertDispatcher: AlertService,
    private route: ActivatedRoute
  ) {
    ClarityIcons.addIcons(twoWayArrowsIcon);
    this.devMode = env.stages.dev;
  }

  ngOnInit(): void {
    const params = this.route.snapshot.paramMap;
    this.projectId = params.get('prid') ?? '';
    this.jobId = parseInt(params.get('jobid') ?? '');
    this.loadJob(this.projectId, this.jobId)
  }

  loadJob(projectId: string, orderId: number) {
    this.jobss.getJobs(projectId, orderId, 'all').subscribe({
      next: data => {
        if (!data || !data.object || data.object.length === 0) {
          this.alertDispatcher.show({
            message: ' Keine Jobdaten gefunden! ',
            clrAlertType: IAlertType.WARNING
          }, 5000);
          return;
        }

        this.jobs = data.object;
        if (this.devMode) console.table(this.jobs[0]);

      },
      complete: () => {},
      error: () => {
        return;
      }
    });
  }
}
